import { useCallback, useEffect, useState } from "react";
import ToggleTabs from "../ChartTableToggle";
import GnaUtilisationVolumeAnylysis from "./GnaUtilisationVolume";
import GnaUtilisationCostAnylysis from "./GnaUtilisationCost";
import DailyAnalysis from "./DailyUtilisation/DailyAnalysis";
import MonthAnalysis from "./DailyUtilisation/MonthAnalysis";
import { fetchOptimalUtilisation } from "../../../Utility/RestApi";
const DataTabs = ["Volume", "Cost"];

export default function GnaTgnaOptimalUtilisationAnylysis({
  selectedBlock,
  refreshKey,
  setError,
  setUniqueTargetDate,
  selectedTargetDate,
}: {
  selectedBlock: any[];
  refreshKey: number;
  setError?: any;
  setUniqueTargetDate?: any;
  selectedTargetDate: any[];
}) {
  const [activeTab, setActiveTab] = useState<string>(DataTabs[0]);
  const [loading, setLoading] = useState(false);
  const [data, setData] = useState<any[]>([]);

  const handleFetchData = useCallback(async () => {
    // if (!preSelectedDate || !modSelectedSession) return;

    try {
      setLoading(true);
      const res = await fetchOptimalUtilisation();
      setUniqueTargetDate(
        Array.from(
          new Set(
            res.map((item: { date: any }) =>
              item.date.split("-").reverse().join("-")
            )
          )
        )
      );
      setData(res);
    } catch (error) {
      console.error("Error fetching data", error);
      setError("An error occurred while fetching data.");
    } finally {
      setLoading(false);
    }
  }, [setError, setUniqueTargetDate]);

  useEffect(() => {
    handleFetchData();
  }, [handleFetchData, refreshKey]);

  return (
    <>
      <div className="load-data grid grid-cols-2 p-0 md:grid-cols-12 grid-rows-full md:grid-rows-2 gap-2 h-full w-full md:overflow-hidden rounded-2xl !shadow-[rgba(149,157,165,0.2)_0px_8px_24px]">
        <div className="dash-card col-span-1 md:col-span-12 border border-[#718EBF1C] !bg-[#fff] !shadow-[rgba(149,157,165,0.2)_0px_8px_24px] !p-2 !min-h-[100%] w-full">
          <div className="flex justify-between items-center mb-1">
            <h2 className="chartHeading w-full">GNA-TGNA Optimal Utilisation</h2>
            <div className="flex items-center gap-3">
              <ToggleTabs
                tabs={DataTabs}
                activeTab={activeTab}
                setActiveTab={setActiveTab}
              />
            </div>
          </div>
          {activeTab === "Volume" && (
            <GnaUtilisationVolumeAnylysis
              selectedBlock={selectedBlock}
              refreshKey={refreshKey}
              setError={setError}
              loading={loading}
              selectedTargetDate={selectedTargetDate}
              data={data}
            />
          )}
          {activeTab === "Cost" && (
            <GnaUtilisationCostAnylysis
              selectedBlock={selectedBlock}
              refreshKey={refreshKey}
              setError={setError}
              loading={loading}
              selectedTargetDate={selectedTargetDate}
              data={data}
            />
          )}
        </div>
        <div className="col-span-1 md:col-span-12 w-full !h-[100%]">
          <div className="flex flex-col md:flex-row gap-2 !h-[100%]">
            <DailyAnalysis
              selectedBlock={selectedBlock}
              refreshKey={refreshKey}
              setError={setError}
              selectedTargetDate={selectedTargetDate}
            />
            <MonthAnalysis
              selectedBlock={selectedBlock}
              refreshKey={refreshKey}
              setError={setError}
              selectedTargetDate={selectedTargetDate}
            />
          </div>
        </div>
      </div>
    </>
  );
}
